// extracted by mini-css-extract-plugin
export default {"badge":"TldlDurationBadge_badge__N5bic","icon":"TldlDurationBadge_icon__P6nTX","text":"TldlDurationBadge_text__UzVgq"};